import React, { useState } from 'react'
import { api, setAdminToken } from '../api'
import { PlatformAdmin } from '../types'

interface Props {
  onLoginSuccess: (admin: PlatformAdmin) => void
}

export function LoginView({ onLoginSuccess }: Props) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim() || !password) {
      setError('Lütfen e-posta ve şifrenizi giriniz.')
      return
    }

    setLoading(true)
    setError(null)

    try {
      const res = await api.login({
        email: email.trim(),
        password,
      })
      setAdminToken(res.access_token)
      onLoginSuccess(res.admin)
    } catch (err: any) {
      setError(err.message || 'Giriş yapılamadı. Bilgilerinizi kontrol ediniz.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-brand-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
            </svg>
          </div>
          <h1>Platform Yönetim Portalı</h1>
          <p>Cost ERP Merkezi Platform Yönetimi & Superadmin Girişi</p>
        </div>

        <form onSubmit={handleSubmit} className="login-body">
          {error && (
            <div className="alert alert-danger" role="alert">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <div className="form-group">
            <label className="form-label form-label-required" htmlFor="admin-email">
              Platform Admin E-Posta
            </label>
            <input
              id="admin-email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@parel.com"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label form-label-required" htmlFor="admin-password">
              Şifre
            </label>
            <input
              id="admin-password"
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••••••"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', padding: '10px 16px', marginTop: '6px' }}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="loading-spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
                <span>Giriş Yapılıyor…</span>
              </>
            ) : (
              'Yönetim Paneline Giriş Yap'
            )}
          </button>

          <p className="login-footer-note">
            Bu portal yalnızca yetkili sistem ve platform yöneticileri içindir.
          </p>
        </form>
      </div>
    </div>
  )
}
